import Image from '@/components/UI/Image';
import { formatLink } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { useMemo } from 'react';
export default function SeriesType({ initData, locale, router }: any) {
    const { Link, isMobile } = useGlobal();
    const Dom = useMemo(() => {
        const homeGoDetail = (url: string) => {
            if (url) {
                router.push(url);
            }
        };
        return (
            <>
                {initData?.map((item: any, itemIndex: number) => (
                    <div className="banner-content1" key={itemIndex} onClick={() => homeGoDetail(JSON.parse(item.buttonText)[0].buttonUrl)}>
                        {item.phonePictureUrl && isMobile && (
                            <Image src={item.phonePictureUrl} className="fullImgs" layout="fill" priority={true} loading="eager" alt={item.mainHeading}></Image>
                        )}
                        {item.webPictureUrl && !isMobile && (
                            <Image src={item.webPictureUrl} className="fullImgs" layout="fill" priority={true} loading="eager" alt={item.mainHeading}></Image>
                        )}

                        <div className="container">
                            <div className="box">
                                {/* <ScrollAnimation animateIn='fadeInLeft'  animateOut='fadeOut'> */}
                                <h2 style={{ color: item.textColor === 'white' ? '#fff' : '#000' }} className="title font-family-bold">
                                    {item.mainHeading}
                                </h2>
                                <p style={{ color: item.textColor === 'white' ? '#fff' : '#000' }} className="des">
                                    {item.subHeading}
                                </p>
                                <div className="link">
                                    {JSON.parse(item.buttonText)[0]?.buttonUrl && (
                                        <Link
                                            {...formatLink(JSON.parse(item.buttonText)[0].buttonUrl)}
                                            style={{ color: JSON.parse(item.buttonText)[0].buttonUrl.btnColor }}
                                            className="msg-linkitem ef-icon-arrowright"
                                            ariaLabel={item.mainHeading}
                                        >
                                            {JSON.parse(item.buttonText)[0].buttonName}
                                        </Link>
                                    )}
                                </div>
                                {/* </ScrollAnimation> */}
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    }, [Image, Link, initData, isMobile, locale, router]);

    return <>{Dom}</>;
}
